import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";
import { Help_Crumbs } from "./Help_General";

export const HelpChartLegend = () => {
    return (
        <>

            <b>Chart behaviours</b><br />
            <li ><b>Hover</b> As you hover over a line it will highlight and the other lines will dim to make it easier to see. </li >
            <li ><b>Click</b> Removes (or adds back) the line/bar associated with that legend</li >
            <li ><b>Double Click</b> Double Clicking will remove all other lines/bars from the chart other than the one selected.  Double Clicking again will cause all lines/bars to come back again.</li>
        </>

    )
}


export const HelpChartCompareScenario = () => {
    return (
        <HelpWindow title="Chart Compare Scenarios " >
            <Typography variant="body1" gutterBottom>
                The chart is compares the accounts or accounts selected over time for each of the scenarios.
                In general the scenario with the higher line (more positive) is better for at least that account.
                <br />

                <HelpChartLegend />
                <Help_Crumbs />

            </Typography>
        </HelpWindow>
    )
}

export const HelpChartDiffScenario = () => {
    return (
        <HelpWindow title="Chart Diff Scenarios " >
            <Typography variant="body1" gutterBottom>
                This chart does a Scenario(2) - Scenario(1) for each of the lines on the normal comparison chart. If the resulting line is POSITIVE then scenario(A) is better for at least that line.  Lines that are NEGATIVE then scenario(A) is worse for that line.<br />
                For example if InvAssets(2) =1000 and InvAssets(1) =800 the chart will show +200, and thus is better for scenario(2).<br />
                If Liabilities(2)=0 and Liabilities(1)=-500 the chart will show +500 which is also again better for scenario(2).<br />
                You can compare multiple scenarios (2,3,4) against scenario (1).  This is helpful so you can see how each of the scenarios compares against each other.  Scenario (1) is basically the 0 line. It's interesting to see how the curve of the difference chages over the course of chart.<br />
                <br />
                <HelpChartLegend />
                <Help_Crumbs />

            </Typography>
        </HelpWindow>
    )
}


export const HelpChartSweep = () => {
    return (
        <HelpWindow title="Chart Sweep  " >
            <Typography variant="body1" gutterBottom>
                <span>
                    The chart is fairly self explanatory.  It compares the accounts or accounts selected over time for each of the scenarios.
                    The lines will be denoted as A@P.  A is the Account name or Account Type.  The P is the parameter wrt the sweep index from 60...70  step 2 so P is 60, 62, ....70.
                </span>
                <br />


                <HelpChartLegend />
                <Help_Crumbs />

            </Typography>
        </HelpWindow>
    )
}

export const HelpChartInOut = ({ arg }) => {
    const getTitle = () => {
        //console.log(arg)
        if (arg !== undefined && arg !== null) {
            return String(arg.split("=")[1].split("&")[0])
        }
        return ""
    }
    const getChartSpecific = () => {
        if (arg === undefined || arg === null) {
            arg = ""
        }
        if (arg.includes("Deductions")) {
            return (
                <span>
                    <b>CPP/QPP Debit vs Deductions</b><br />
                    Basic CPP/QPP are debits since you pay them but they are are still included in the basic tax, but then you get a non-refundable tax-credit against the value of the debit (see Tax Amounts).  We show it here as the debit which is what you will pay (you pay tax + EI/QEI/CPP/QPP) and then a portion of that will show up as a tax credit in the tax reporting.  That way it's done at the lowest tax bracket rather than a deduction which would effectively get a tax credit be done at your marginal tax rate.<br />
                    However CPP/QPP First and Second Enhanced Contributions are deductions and as such taken directly off the top of the income before your TaxableIncome is calculated.<br />
                    Weird ... but that's the way it is ...  Does it make much difference ... not much really .... but we strive to be correct here at MyOwnFP so we want to make sure its calculated correctly.<br /><br />
                    <a href="https://www.canada.ca/en/revenue-agency/services/forms-publications/payroll/t4032-payroll-deductions-tables/t4032oc-jan/t4032oc-january-general-information.html#_Toc337712808" target="_blank" rel="noopener noreferrer">CPP Calculations</a><br />

                </span>

            )
        }
        return (
            <span>
            </span>
        )
    }
    return (
        <HelpWindow title={"Chart In/Out -- " + getTitle()} >
            <Typography variant="body1" gutterBottom>
                {getChartSpecific()}
                <span>
                    <b>In/Out</b><br />
                    The bars on this chart money that are coming into the account.  It will be denoted in the Form F:R where F is the account the money came from and R indicates the type of return that the bar indicates.<br />
                    The value can be positive normally, and in some cases negative to indicate that money has been taken from the account to another account.<br />
                    If this chart includes multiple accounts the values will be denoted A:F:R where A is the account the money went to.<br />
                    The total line shows the value of the account at the end of the year.<br />
                    There may be a Cost Basis line for the chart if the account is a not a Registered account.<br />
                    There may be a Contribution line on the chart which for Registered accounts will show the cumulative contributions to the account.
                </span>
                <br />


                <HelpChartLegend />
                <Help_Crumbs />


            </Typography>
        </HelpWindow>
    )
}
export const HelpChartByAccount = (arg) => {
    const getTitle = () => {

    }
    return (
        <HelpWindow title="Chart Value by Account  " >
            <Typography variant="body1" gutterBottom>
                <span>
                    The bars on this are the value of each of the accounts that make up this type of chart.
                    The total line shows the sum value of the accounts at the end of the year.
                    There may be a Cost Basis line for the chart if the account is a not a Registered account.
                    There may be a Contribution line on the chart which for Registered accounts will show the cumulative contributions to the account.
                </span>
                <br />


                <HelpChartLegend />
                <Help_Crumbs />

            </Typography>
        </HelpWindow>
    )
}
export const HelpChartTaxAmounts = () => {
    return (
        <HelpWindow title="Chart Tax Amounts  " >
            <Typography variant="body1" gutterBottom>
                <span>
                    The bars here are the value of the different Taxes that are levied.  These are denoted by J:T, J being the Tax Jurisdiction and T the specific tax.
                    If the bars are negative the notation is J:C where C is the value of a credit.
                    The main line on the chart denoting the Net Tax for the given year
                    It For Tax Rate lines these show the  marginal and overall tax rates for each year.
                    For the Joint 'person' the Marginal Tax rate is the higher if either the client/partner tax rate, while the Overall tax rate is the average tax rate (total tax/total income)

                </span>
                <br />


                <HelpChartLegend />
                <Help_Crumbs />

            </Typography>
        </HelpWindow>
    )
}
export const HelpChartTaxRates = () => {
    return (
        <HelpWindow title="Chart Tax Rates  " >
            <Typography variant="body1" gutterBottom>
                It For Tax Rate lines these show the  marginal and overall tax rates for each year.
                For the Joint 'person' the Marginal Tax rate is the higher if either the client/partner tax rate, while the Overall tax rate is the average tax rate (total tax/total income)
                <br />

                <HelpChartLegend />
                <Help_Crumbs />
            </Typography>
        </HelpWindow>
    )
}
export const HelpChartAccountLines = () => {
    return (
        <HelpWindow title="Chart MultiLine  " >
            <Typography variant="body1" gutterBottom>
                The chart is fairly self explanatory.  It compares the accounts or accounts selected over time.
                <br />

                <HelpChartLegend />
                <Help_Crumbs />

            </Typography>
        </HelpWindow>
    )
}


export const HelpChart = ({ chart, arg }) => {
    const getHelp = () => {

        if (chart === "chart") {
            if (arg.includes("inout=true")) {
                return <HelpChartInOut arg={arg} />
            } else if (arg.includes("byAcct=true")) {
                return <HelpChartByAccount arg={arg} />
            }
            return < HelpChartInOut />
        } else if (chart === "taxchart") {
            return <HelpChartTaxAmounts />
        } else if (chart === "taxratechart") {
            return <HelpChartTaxRates />
        } else if (chart === "linechart") {
            if (arg.includes("cmp=")) {
                return <HelpChartCompareScenario />
            }
            return <HelpChartAccountLines />
        } else if (chart.includes("diffchart")) {
            return <HelpChartDiffScenario />
        }

    }
    return (
        getHelp()
    )
}



